import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "distribution-centers",
  "title": "Distribution Centers",
  "summary": "Waste reduction and recycling systems for cardboard, packaging materials, and mixed facility streams.",
  "image": "equipment/horizontal-balers/horizontal-1.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['distribution-centers'];


function DistributionCenters() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"Distribution centers commonly handle cardboard, packaging, small cartons, pallet-area scrap, and mixed recyclable material that benefits from organized collection, conveying, and baling."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Distribution Center Waste Streams</h3>
              <div className="body-copy">Distribution centers commonly handle cardboard, packaging, small cartons, pallet-area scrap, and mixed recyclable material that benefits from organized collection, conveying, and baling.</div>
              <div className="body-copy">C+M systems can combine cart dumpers, conveyors, <strong>horizontal balers</strong>, <strong>vertical balers</strong>, and compactors depending on volume, labor availability, and floor space.</div>
              <div className="detail-points">
                <div className="detail-point">Cardboard and packaging waste</div>
                <div className="detail-point">Cart dumping and conveyor loading</div>
                <div className="detail-point">Baling and compacting to reduce hauling and storage burden</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default DistributionCenters;
